import styled from 'styled-components';

export const StyledMowerStatusPresentation = styled.div`
  h2 {
    color: red;
  }
  h3 {
    color: green;
  }
`;
